<template>
  <main v-if="status">
    <main-header :data="data" />
    <transition name="fade" mode="out-in">
      <router-view :data="data" />
    </transition>
    <main-footer />
    <main-chat v-if="chatStatus" />
  </main>
  <loading v-else />
</template>

<script>
import Loading from "@/components/Loading.vue";
import MainHeader from "@/components/header/Header.vue";
import MainFooter from "@/components/MainFooter.vue";
import MainChat from "@/components/chat/Home.vue";
import * as API from "@/services/individual/";
export default {
  components: {
    MainHeader,
    MainFooter,
    MainChat,
    Loading,
  },
  data() {
    return {
      chatStatus: false,
      data: {
        contracts: null,
        policies: null,
        openPremiums: null,
        upComingPremiums: null,
        lifeAndPersonalCount: 0,
        healtCount: 0,
        total: null,
        user: null,
      },
      status: false,
      user: this.$store.getters.getUserInfo,
      banktype: this.$store.getters.getBankType,
    };
  },
  watch: {
    $route() {
      this.$store.dispatch("setLoading", false);
      this.checkChatStatus();
    },
    data: {
      deep: true,
      handler: "isChange",
    },
  },
  created() {
    this.checkChatStatus();
    if (this.banktype == "corporate") return (this.status = true);
    this.getContracts();
    this.getPolicies();
    this.getUser();
  },
  methods: {
    getContracts: async function () {
      let vm = this;

      let storeUser = vm.$store.getters.getUserInfo;

      if (storeUser.isVizyoneksCustomer == "false") {
        vm.data.contracts = [];
        vm.data.total = 0;
        return;
      }

      let form = {
        yi: "Y",
      };

      let response = await API.getCustomerPolicies(form)
        .then((response) => {
          return response;
        })
        .catch(() => {
          return {
            result: {
              openPremiums: [],
              upComingPremiums: [],
              customerProducts: [],
              customersOtherProducts: [],
            },
          };
        });

      vm.data.openPremiums = response.result.openPremiums;
      vm.data.upComingPremiums = response.result.upComingPremiums;

      let data = [
        ...response.result.customerProducts,
        ...response.result.customersOtherProducts,
      ];

         //Added new
       data.forEach((x)=>{
         if(x.birikimTipAciklama !="BES" && x.birikimTip !="B"){
           vm.data.lifeAndPersonalCount ++;
         }
       })


      vm.data.contracts = data.map((item) => {
        let type = "me";

        if (
          parseInt(storeUser.vizyoneksCustomerNo) == item.borcluNo &&
          parseInt(storeUser.vizyoneksCustomerNo) != item.sigortaliNo
        )
          type = "love";

        return {
          ...item,
          provider: "vizyoneks",
          type,
        };
      });

      vm.data.total = vm.data.contracts
        .filter((item) => item.birikimTipAciklama == "BES" && item.type == "me")
        .reduce(
          (total, item) => total + (item.fonBuyukluguDK + item.fonBuyukluguKK),
          0
        );
    },
    getPolicies: async function () {
      let vm = this;

      let storeUser = vm.$store.getters.getUserInfo;

      if (storeUser.isAgitoCustomer == "false") return (vm.data.policies = []);

      let form = {
        CustomerId: parseInt(storeUser.agitoCustomerNo),
      };

      let response = await API.getMyInsurances(form);
      if (!response.model) response.model = [];

      vm.data.healtCount = response.model.filter(
        (item) => item.policystatusId != 5
      ).length;

      vm.data.policies = response.model
        .filter((item) => item.policystatusId != 5) //geçmiş poliçe olmayanlar
        .map((item) => {
          return {
            ...item,
            provider: "agito",
            type: item.customerRoleId == 1 ? "me" : "love",
          };
        });
    },
    getUser: async function () {
      let vm = this;

      let response = await API.getUser();

      let user = response.result;

      let storeUser = vm.$store.getters.getUserInfo;

      user.agitoCustomerNo = storeUser.agitoCustomerNo;
      user.vizyoneksCustomerNo = storeUser.vizyoneksCustomerNo;
      user.tckn = storeUser.tckn;

      vm.data.user = user;
    },
    isChange: function () {
      this.status =
        !!this.data.contracts && !!this.data.policies && !!this.data.user;
    },
    checkChatStatus: function () {
      // let now = new Date();
      // let dayOfWeek = now.getDay();
      // let isWeekend = dayOfWeek === 6 || dayOfWeek === 0; // cumartesi ya da pazar mı?
      // let hourOfday = now.getHours();
      // let isWorkingHour = hourOfday > 8 && hourOfday < 20; // mesai saati içerisinde mi? 09:00-19:00
      // let status = !isWeekend && isWorkingHour;
      // this.chatStatus = status;
      this.chatStatus = false;
    },
  },
};
</script>